'use client'

import React, {memo} from 'react'

import searchIcon from '@/src/shared/assets/media/icon-search-white.svg'

import * as UI from './search.styles'

export const HeaderSearch = memo(function Component() {
  return (
    <>
      <UI.SearchButton
        id="title-search-input"
        type="button"
        title="Найти"
        value="Найти"
        data-input
        $iconUrl={searchIcon.src}
      />
    </>
  )
})
